import { render, staticRenderFns } from "./myActiveCoins.vue?vue&type=template&id=1fbf4a98&scoped=true"
import script from "./myActiveCoins.vue?vue&type=script&lang=js"
export * from "./myActiveCoins.vue?vue&type=script&lang=js"
import style0 from "./myActiveCoins.vue?vue&type=style&index=0&id=1fbf4a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf4a98",
  null
  
)

export default component.exports